'use client';

import { c as _c } from "react/compiler-runtime";
import { ResizableContainer } from '@/comps/buttons/ResizableContainer';
import { Sheet, SheetContent } from '@/comps/primitives/sheet';
import { DoubleArrowRightIcon } from '@radix-ui/react-icons';
import type { ReactNode } from 'react';
import { useRef } from 'react';
type PagesResizableSheetProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
  className?: string;
  initialWidth?: number;
  minWidth?: number;
};
export function PagesResizableSheet(t0) {
  const $ = _c(18);
  const {
    open,
    onOpenChange,
    children,
    className,
    initialWidth: t1,
    minWidth: t2
  } = t0;
  const initialWidth = t1 === undefined ? 600 : t1;
  const minWidth = t2 === undefined ? 400 : t2;
  const closeButtonRef = useRef(null);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = event => {
      event.preventDefault();
      closeButtonRef.current?.focus();
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== onOpenChange) {
    t4 = () => onOpenChange(false);
    $[1] = onOpenChange;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DoubleArrowRightIcon className="h-4 w-4" strokeWidth={1} />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4) {
    t6 = <div className="flex shrink-0 items-center border-b border-lightborder px-6 py-4"><button ref={closeButtonRef} type="button" className="rounded-sm text-muted-foreground hover:cursor-pointer hover:text-accent-foreground focus:outline-hidden focus-visible:ring-2 focus-visible:ring-ring" onClick={t4} aria-label="Close drawer">{t5}</button></div>;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = className ?? "flex min-h-0 flex-1 flex-col overflow-hidden";
  let t8;
  if ($[6] !== children || $[7] !== t7) {
    t8 = <div className={t7}>{children}</div>;
    $[6] = children;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== initialWidth || $[10] !== minWidth || $[11] !== t6 || $[12] !== t8) {
    t9 = <SheetContent side="right" className="flex h-full justify-end overflow-hidden p-0" onOpenAutoFocus={t3}><ResizableContainer handlePosition="start" direction="x" minWidth={minWidth} initialWidth={initialWidth} initialHeight="full" className="flex h-full flex-col">{t6}{t8}</ResizableContainer></SheetContent>;
    $[9] = initialWidth;
    $[10] = minWidth;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== onOpenChange || $[15] !== open || $[16] !== t9) {
    t10 = <Sheet open={open} onOpenChange={onOpenChange}>{t9}</Sheet>;
    $[14] = onOpenChange;
    $[15] = open;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}